import { Pipe, PipeTransform, Injectable } from '@angular/core'

@Pipe({
  name: 'falsyFilter',
})
@Injectable()

/* Custom filter pipe to filter out falsy values like false, null, 
undefined, empty strings(""), empty strings with spaces(" ") from an array */
export class FalsyFilter implements PipeTransform {
  transform(items: any[]): any[] {
    if (!items) {
      return []
    }
    return items.filter((item) => item.trim())
  }
}
